import { attachDynamicEvent } from '~/common/helpers/dom'
import { processFormSubmission } from './common'

/*
  A payment window is a payment processor where the process is started by the user's browser submitting to the payment
  provider's website. When the user submits the checkout, we generate a form, put it on page, then have the browser
  submit it. Then the payment processor handles everything else.
  The process for a saved or new quickpay payment is similar unlike some other processors
*/

function submitIfWithQuickpayLink(event) {
  if (
    getSelectedQuickpayLinkProcessorOption() ||
    getSelectedSavedQuickpayLinkOption()
  ) {
    submitWithQuickpayLink(event)
  }
}

async function submitWithQuickpayLink(event) {
  event.preventDefault()

  let submitButton = event.target
  let form = submitButton.closest('form')

  processFormSubmission(form, {
    onSuccess: (json) => {
      window.top.location.href = json.redirect
    },
    onError: (json) => {
      console.log('QuickPay submit received error: ' + JSON.stringify(json))
      let alertMessage = "We're sorry, we could not process your order."
      if (json.error) {
        alertMessage += '\n\n' + json.error
      }
      alert(alertMessage)
    },
  })
}

function getSelectedQuickpayLinkProcessorOption() {
  return document.querySelector(
    '.cart-checkout-payment .payment-processor-option-quickpay-link input[type=radio]:checked, ' +
      ".cart-checkout-payment input[type=hidden][name='payment_method'].payment-processor-option-quickpay-link"
  )
}

function getSelectedSavedQuickpayLinkOption() {
  return document.querySelector(
    '.cart-checkout-payment .payment-method-option-quickpay-link input[type=radio]:checked'
  )
}

attachDynamicEvent(
  '.cart-checkout-payment .submit-payment',
  'click',
  submitIfWithQuickpayLink
)
